import { useCallback, useEffect, useRef } from 'react';

import { useDialogStore } from '@/store';

export function useOpenGlobalSearch() {
  const { openGlobalSearch, isGlobalSearchOpen } = useDialogStore();

  // Use a ref to avoid recreating the handler on every render
  const handlerRef = useRef<(event: KeyboardEvent) => void>(() => {});

  // Memoize the handler creation
  handlerRef.current = useCallback(
    (event: KeyboardEvent) => {
      const isF2 = event.key === 'F2';
      const isCtrlK = (event.ctrlKey || event.metaKey) && event.key === 'k';

      if ((isF2 || isCtrlK) && !isGlobalSearchOpen) {
        event.preventDefault();
        event.stopPropagation();
        openGlobalSearch();
      }
    },
    [openGlobalSearch, isGlobalSearchOpen],
  );

  useEffect(() => {
    // Use a stable reference to the handler
    const handleKeyPress = (event: KeyboardEvent) => {
      handlerRef.current?.(event);
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, []); // Empty dependency array since we're using refs

  return null;
}
